import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import supportReducer from "./supportSlice"; 
import iMessageReducer from "./iMessageSlice";
import notificationsReducer from "./notificationsSlice";
import commercePartnersReducer from "./commercePartnersSlice";

import { storeProductsReducer } from "./storeProductSlice";
import storeCartReducer from "./storeCartSlice";
import storeOrdersReducer from "./storeOrdersSlice";
import storeProductRatingsReducer from "./storeProductRatingSlice";
import storeProductServiceFeeReducer from "./storeProductServiceFeeSlice";



import socialReducer from "./socialSlice";
import glamourBrandsReducer from "./glamourBrandsSlice";
import glamourServiceFeesReducer from "./Glamourservicefeeslice";
import glamourRatingsReducer from "./glamourRatingSlice";
import glamourReducer from './glamourSlice';
import glamourOrdersReducer from './glamourOrdersSlice'


import commerceServiceFeesReducer from "./commerceServiceFeeSlice";

import deliveryFeesReducer from "./deliveryFeesSlice";
import productServiceFeeReducer from "./productServiceFeeSlice";

import cartReducer from "./cartSlice";
import productsReducer from "./productSlice";
import productRatingsReducer from "./productRatingSlice";
import productOrdersReducer from "./productOrdersSlice";
import commerceOrdersReducer from "./commerceOrdersSlice";

import booksReducer from "./bookSlice";

import groceriesReducer from "./groceriesSlice";
import groceryOrdersReducer from "./groceriesOrderSlice";

import foodReducer from "./foodSlice";
import FoodOrderReducer from "./foodOrderSlice";
import foodServiceFeeReducer from "./foodServiceFeeSlice"; 

import serviceFeeReducer from "./serviceFeeSlice";

import payoutMethodReducer from "./payoutMethodSlice";
import payoutsReducer from "./payoutsSlice";
import paymentMethodsReducer from "./paymentMethodSlice";
import payoutDetailsReducer from "./payoutDetailsSlice";


import operatorReducer   from "./operatorSlice";
import driversReducer    from "./driversSlice";
import riderServiceFeeReducer from "./riderServiceFeeSlice";   
import riderReservationReducer from "./riderReservationSlice";



import fleetReducer from "./fleetSlice";



import shortstaysReducer from './shortstaysSlice';
import shortstayServiceFeeReducer from "../redux/shortstayServiceFeeSlice"; 
import shortstayReservationReducer from "../redux/shortstayReservationSlice"; 
import shortRatingReducer from './shortRatingSlice';
import shortGuestRatingReducer from "./shortGuestRatingSlice";
import wishlistReducer from './wishlistSlice';


// --- Cleaning imports ---
import cleaningReducer from "./cleaningSlice";
import cleaningReservationReducer from "./cleaningReservationSlice";
import cleaningServiceFeeReducer from "./cleaningFeeSlice";
import cleaningGuestRatingReducer from "./cleaningGuestRatingSlice";
import cleaningRatingReducer from "./cleaningRatingSlice";


export const store = configureStore({
  reducer: {
    auth: authReducer,
    support: supportReducer,
  imessage: iMessageReducer,




    storeProducts: storeProductsReducer,
   storeCart: storeCartReducer,
    storeOrders: storeOrdersReducer,
    storeProductRatings: storeProductRatingsReducer,
    storeProductServiceFee: storeProductServiceFeeReducer,




    glamourBrands: glamourBrandsReducer,
commerceOrders: commerceOrdersReducer,
        notifications: notificationsReducer,
            social: socialReducer,
                
            
commercePartners: commercePartnersReducer,
 commerceServiceFees: commerceServiceFeesReducer,
    

     cart: cartReducer,
products: productsReducer,
productOrders: productOrdersReducer,
productRatings: productRatingsReducer,
deliveryFees: deliveryFeesReducer,
productServiceFee: productServiceFeeReducer,

books: booksReducer,

groceries: groceriesReducer,
  foodOrder: FoodOrderReducer,
groceryOrders: groceryOrdersReducer,

food: foodReducer,
foodServiceFee: foodServiceFeeReducer,


  serviceFee: serviceFeeReducer, 


 glamour: glamourReducer,
 glamourOrders: glamourOrdersReducer,
glamourServiceFees: glamourServiceFeesReducer,
glamourRatings: glamourRatingsReducer,





       payouts: payoutsReducer,
     payoutMethod: payoutMethodReducer,
paymentMethods: paymentMethodsReducer,
payoutDetails: payoutDetailsReducer,


 operator:   operatorReducer,
    drivers:    driversReducer,
    riderServiceFee: riderServiceFeeReducer,
rider: riderReservationReducer,



fleet: fleetReducer,





shortstays: shortstaysReducer,
  shortstayServiceFees: shortstayServiceFeeReducer,
  shortstayReservations: shortstayReservationReducer,
  shortRatings: shortRatingReducer,
  shortGuestRatings: shortGuestRatingReducer,
wishlist: wishlistReducer,

  // ── Cleaning ──────────────────────────────────────
  cleaning: cleaningReducer,
  cleaningReservations: cleaningReservationReducer,
  cleaningServiceFees: cleaningServiceFeeReducer,
  cleaningGuestRatings: cleaningGuestRatingReducer,
  cleaningRatings: cleaningRatingReducer,
  // ──────────────────────────────────────────────────


  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;